import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

type HostConversionCompleteStore = {
  completeTime: string
  isHydrated: boolean
  actions: {
    updateCompleteTime: (data: string) => void
    updateIsHydrated: () => void
    reset: () => void
  }
}
const initialState = {
  completeTime: '',
  isHydrated: false,
}

export const useHostConversionCompleteStore =
  create<HostConversionCompleteStore>()(
    persist(
      set => ({
        ...initialState,
        actions: {
          updateCompleteTime: data => {
            set(() => ({
              completeTime: data,
            }))
          },
          updateIsHydrated: () => {
            set(() => ({
              isHydrated: true,
            }))
          },
          reset: () => {
            set(initialState)
          },
        },
      }),
      {
        name: 'host-conversion-complete',
        storage: createJSONStorage(() => sessionStorage),
        partialize: state => ({
          completeTime: state.completeTime,
        }),
      },
    ),
  )
